export default "__VITE_ASSET__Buo3nVDi__"